import React, { useState, useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Loader from './components/Loader/Loader';
import DashboardPage from './pages/dashboard/dashboard';
import LoginForm from './LoginForm';
// L'import est déjà là, c'est parfait
import { AuthProvider } from './AuthContext';
import PrivateRoute from './PrivateRoute';

const Home = React.lazy(() => import('./pages/Home/Home'));
const Apropos = React.lazy(() => import('./pages/Apropos/Apropos'));
const Agenda = React.lazy(() => import('./pages/agenda/agenda'));
const Collaboration = React.lazy(() => import('./pages/Collaboration/Collaboration'));
const Contact = React.lazy(() => import('./pages/Contact/Contact'));
const Inscription = React.lazy(() => import('./pages/Inscription/Inscription'));
const EditionPage = React.lazy(() => import('./pages/EditionPage/EditionPage'));
const Participant = React.lazy(() => import('./pages/participant/participant'));
const Exposant = React.lazy(() => import('./pages/exposant/exposant'));


function App() {
  const [isLoadedOnce, setIsLoadedOnce] = useState(!!sessionStorage.getItem('isLoadedOnce'));

  useEffect(() => {
    if (!isLoadedOnce) {
      const timer = setTimeout(() => {
        setIsLoadedOnce(true);
        sessionStorage.setItem('isLoadedOnce', 'true');
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [isLoadedOnce]);

  if (!isLoadedOnce) {
    return <Loader />;
  }
  
  return (
    // ON AJOUTE LE PROVIDER ICI POUR ENGLOBER TOUTE L'APPLICATION
    <AuthProvider>
      <Router>
        <Suspense fallback={<div></div>}>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Navbar/>
                  <Home />
                  <Footer />
                </>
              }
            />
            <Route 
            path="/apropos" 
            element={
            <>
            <Navbar />
            <Apropos />
            <Footer />
            </>}
            />
            <Route
            path="/collaboration"
              element={
              <>
              <Navbar />
              <Collaboration />
              <Footer />
              </>}
              />
            <Route
            path="/programme"
              element={
              <><Navbar />
              <Agenda />
              <Footer />
              </>}
              />
            <Route
            path="/contact"
              element={
              <>
              <Navbar />
              <Contact />
              <Footer />
              </>} 
              />
            <Route 
            path="/inscription"
            element={
            <>
            <Navbar />
            <Inscription />
            <Footer />
            </>
            } 
            />
            <Route
            path="/editions/:slug"
            element={
            <>
            <Navbar />
            <EditionPage />
            <Footer />
            </>
            }
            />
            {/* Anciennes URLs figées — redirigées vers les slugs dynamiques */}
            <Route path="/edition1" element={<Navigate to="/editions/edition1" replace />} />
            <Route path="/edition2" element={<Navigate to="/editions/edition2" replace />} />
            <Route path="/legacy" element={<Navigate to="/editions/legacy" replace />} />
            <Route
              path="/login"
              element={
                <>
                  <Navbar />
                  <LoginForm />
                  <Footer />
                </>
              }
            />
            <Route
            path="/participant" 
            element={
            <Participant />
            } 
            />
              {/* Le PrivateRoute a maintenant accès au contexte d'authentification */}
              <Route
              element={<PrivateRoute />}
            >
              <Route path="/dashboard" element={<DashboardPage />} />
            </Route>
            <Route
            path="/exposant" 
            element={
            <Exposant />
            } 
            />
            
          </Routes>
        </Suspense>
      </Router>
    </AuthProvider> // ON FERME LE PROVIDER ICI
  );
}

export default App;